var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrolley(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "26.000000pt",
    height: "26.000000pt",
    viewBox: "0 0 26.000000 26.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,26.000000) scale(0.100000,-0.100000)",
    fill: "#FFFFFF",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 140 c-1 -55 -2 -105 -3 -112 -1 -6 5 -13 12 -16 7 -2 12 5 12 17 0 20 5 21 90 21 85 0 90 -1 90 -21 0 -12 5 -19 13 -17 6 3 12 10 11 16 -1 7 -2 57 -2 112 -1 59 -6 100 -12 100 -5 0 -10 -16 -10 -35 l0 -35 -90 0 -90 0 0 35 c0 19 -4 35 -10 35 -6 0 -11 -41 -11 -100z m201 -35 l0 -45 -90 0 -90 0 0 45 0 45 90 0 90 0 0 -45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 105 c-2 -29 1 -35 17 -35 26 0 33 13 25 45 -10 39 -39 33 -42 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146 115 c-8 -32 -1 -45 25 -45 16 0 19 6 17 35 -3 43 -32 49 -42 10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 224 c-12 -31 -6 -44 19 -44 25 0 31 13 19 44 -3 9 -12 16 -19 16 -7 0 -16 -7 -19 -16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146 224 c-12 -31 -6 -44 19 -44 25 0 31 13 19 44 -3 9 -12 16 -19 16 -7 0 -16 -7 -19 -16z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrolley);
export default __webpack_public_path__ + "static/media/trolley.73f59a11660c05e9c5820ddd2bbe9a5a.svg";
export { ForwardRef as ReactComponent };